import { type SxProps, type Theme } from '@mui/system';
import Bg from '../../assets/login-background.png';

const INFO_WIDTH = 500;

export const contentSx: SxProps<Theme> = {
  display: 'inline-block',
  padding: {
    xs: '26px',
    md: '32px 30px',
    lg: '32px 150px',
  },
  width: '100%',
  minHeight: '100vh',
  background: `url(${Bg})`,
  backgroundSize: 'cover',
  overflowY: 'auto',
};

export const titleSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
  rowGap: '10px',
  alignItems: {
    md: 'flex-end',
  },
  justifyContent: 'space-between',
  '& .title': {
    fontWeight: 'bold',
    fontSize: '28px',
    lineHeight: '34px',
    color: '#006EC2',
    '&.report': {
      textDecoration: 'underline',
      '&:hover': {
        cursor: 'pointer',
      },
    },
  },
  '& .admin-btn': {
    marginLeft: '25px',
    backgroundColor: '#006EC2',
    width: '100px',
    height: '25px',
    textTransform: 'capitalize',
    fontSize: '18px',
    fontWeight: 'normal',
  },
  // TODO: independent
  '& .legend': {
    display: 'block',
    width: '10px',
    height: '10px',
    marginLeft: '30px',
    marginRight: '8px',
    borderRadius: '2px',
  },
  '& .completed': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#006EC2',
    '& .legend': {
      background: '#006EC2',
    },
  },
  '& .processing': {
    display: 'flex',
    alignItems: 'center',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#707070',
    '& .legend': {
      background: '#707070',
    },
  },
  '& .course-search': {
    height: '35px',
    border: '1px solid #006EC2',
    width: {
      xs: 'auto',
      md: '280px',
    },
    outline: 'none !important',
    marginLeft: '10px',
    borderRadius: '3px',
    paddingRight: '35px',
  },
};

export const infoSx: SxProps<Theme> = {
  display: 'inline-block',
  background: 'rgb(228, 239, 247)',
  width: `${INFO_WIDTH}px`,
  padding: '22px 25px',
  boxSizing: 'border-box',
};
